import { render, staticRenderFns } from "./SMSLogs.vue?vue&type=template&id=6a3269c9&"
import script from "./SMSLogs.vue?vue&type=script&lang=js&"
export * from "./SMSLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports